import React, { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./Header.module.css";
import { OnlineReservationContext } from "../index";

const OnlineReservationHeader = () => {
  const { business } = useContext(OnlineReservationContext);

  return (
    <Row className={"mb-3"}>
      <Col md={9}>
        {business?.logo?.url ? (
          <img src={business.logo.url} alt={business.name} className={styles.logo} />
        ) : (
          <p className="h4 mb-0">{business?.name}</p>
        )}
      </Col>
      <Col md={3}></Col>
    </Row>
  );
};

export default OnlineReservationHeader;
